export default __webpack_public_path__ + "static/media/Muron.9d6f3682.mp4";